import React, { FC } from "react";

export const SwiperNavigation: FC<{
  className?: string;
  size?: "regular" | "lg";
}> = ({ className, size }) => {
  return (
    <div
      className={`swiperNavigation swiperNavigation_${size || "regular"} ${
        className ? className : ""
      }`}
    >
      <button className="swiperNavigation--btn swiperNavigation--btn--left">
        <svg
          width="8"
          height="16"
          viewBox="0 0 8 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 14.957L2 7.95703L7 0.957031"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      </button>
      <button className="swiperNavigation--btn swiperNavigation--btn--right">
        <svg
          width="8"
          height="16"
          viewBox="0 0 8 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 14.957L6 7.95703L1 0.957031"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      </button>
    </div>
  );
};
